import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import PropertyUtil from 'src/util/PropertyUtil';
import { RouteComponentProps } from 'react-router-dom';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { IRootState } from 'src/reducers';
import { connect } from 'react-redux';
import { ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import IOwner from 'src/models/IOwner';
import IndividualOwnerForm from './IndividualOwnerForm';
import OwnerTrustForm from './OwnerTrustForm';
import BusinessOwnerForm from './BusinessOwnerForm';
import BOLMOwnerForm from './BOLMOwnerForm';
import RALOwnerForm from './RALOwnerForm';
import StateLandOwnerForm from './StateLandOwnerForm';
import PhoneNumberType from 'src/models/PhoneNumberType';
import JointTenantOwnerForm from './JointTenantOwnerForm';

export interface IEditOwnerPageStateProps {
    states: PagedResultSet<State>;
    ownerData: LeaseGenerationOwnerData;
    pageUpdated: boolean;
    phoneNumberTypes: Array<PhoneNumberType>;
}

export interface IEditOwnerPageDispatchProps {
    getStates: (options: ODataOptions) => void;
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => void;
    updateIndividualOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateTrustOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateBusinessOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateGovBOLMOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateGovRALOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateGovStateLandOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    updateJointTenantOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    // updateOwnerDetail: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => void;
    getPhoneNumberTypes: () => void;
    resetBanner: () => void;
}

type IEditOwnerProps = RouteComponentProps<{ clientNumber?: string; projectNumber?: string; ownerId?: string }> &
    IEditOwnerPageStateProps &
    IEditOwnerPageDispatchProps;

class EditOwnerPage extends React.Component<IEditOwnerProps> {
    constructor(props: IEditOwnerProps) {
        super(props);
    }

    private projectNumber: number;
    private ownerId: number;
    private clientNumber: number;

    public componentDidMount() {
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.projectNumber = parseInt(this.props.match.params.projectNumber, 10);
        this.ownerId = parseInt(this.props.match.params.ownerId, 10);

        this.props.getOwnerData(this.clientNumber, this.projectNumber, this.ownerId);
        this.props.getStates(new ODataOptions().addPaging(1, 100));
        this.props.getPhoneNumberTypes();
    }

    public componentDidUpdate(prevProps: IEditOwnerProps) {
        if (this.props.pageUpdated === true) {
            setTimeout(() => {
                this.props.resetBanner();
            }, 2000);
        }
    }

    handleOnSubmitIndividualOwner = (formValues: IOwner) => {
        console.log('is this the ownerLookupId??', this.ownerId);
        this.props.updateIndividualOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitTrustOwner = (formValues: IOwner) => {
        console.log('is this the ownerLookupId??', this.ownerId);
        this.props.updateTrustOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitBusinessOwner = (formValues: IOwner) => {
        console.log('is this the ownerLookupId??', this.ownerId);
        this.props.updateBusinessOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitGovBOLMOwner = (formValues: IOwner) => {
        this.props.updateGovBOLMOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitGovRALOwner = (formValues: IOwner) => {
        this.props.updateGovRALOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitGovStateLandOwner = (formValues: IOwner) => {
        this.props.updateGovStateLandOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    handleOnSubmitJointTenantOwner = (formValues: IOwner) => {
        this.props.updateJointTenantOwner(this.clientNumber, this.projectNumber, this.ownerId, formValues);
    };

    public render() {
        console.log(
            'ownerdata',
            PropertyUtil.SafeGet(() => this.props.ownerData)
        );
        const ownerType = PropertyUtil.SafeGet(() => this.props.ownerData.ownerDetails.ownerType);
        // Display the appropriate form based on the Owner Type
        return (
            <>
                {this.props.pageUpdated && (
                    <>
                        <div
                            id="dirtyFlag"
                            style={{
                                position: 'fixed',
                                top: '4.7rem',
                                left: '0',
                                width: '100%',
                                color: 'white',
                                backgroundColor: 'rgba(0,150,0,.5)',
                                zIndex: 9000,
                                padding: '1rem 0',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <div>Owner Info updated successfully!</div>
                        </div>
                    </>
                )}
                <br />
                <div>
                    {ownerType === 'Individual' && (
                        <IndividualOwnerForm
                            handleOnSubmit={this.handleOnSubmitIndividualOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'Trust' && (
                        <OwnerTrustForm
                            handleOnSubmit={this.handleOnSubmitTrustOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'Business' && (
                        <BusinessOwnerForm
                            handleOnSubmit={this.handleOnSubmitBusinessOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'Gov-BLM' && (
                        <BOLMOwnerForm
                            handleOnSubmit={this.handleOnSubmitGovBOLMOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'Gov-RAL' && (
                        <RALOwnerForm
                            handleOnSubmit={this.handleOnSubmitGovRALOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'Gov-STATE' && (
                        <StateLandOwnerForm
                            handleOnSubmit={this.handleOnSubmitGovStateLandOwner}
                            ownerData={this.props.ownerData}
                            states={this.props.states}
                            phoneNumberTypes={this.props.phoneNumberTypes}
                        />
                    )}
                    {ownerType === 'JointTenant' && (
                        <div>
                            <JointTenantOwnerForm handleOnSubmit={this.handleOnSubmitJointTenantOwner} ownerData={this.props.ownerData} />
                        </div>
                    )}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IRootState): IEditOwnerPageStateProps => ({
    ownerData: selectors.leaseGeneration.leaseGenerationOwnerData(state),
    pageUpdated: selectors.owner.pageUpdatedSelector(state),
    states: selectors.state.states(state),
    phoneNumberTypes: selectors.phoneNumberType.phoneNumberTypes(state),
});

const mapDispatchToProps: IEditOwnerPageDispatchProps = {
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => actions.leaseGeneration.getOwnerData({ clientId, projectId, ownerId }),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
    updateIndividualOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateIndividualOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateTrustOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateTrustOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateBusinessOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateBusinessOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateGovBOLMOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateGovBOLMOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateGovRALOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateGovRALOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateGovStateLandOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateGovStateLandOwner(clientNumber, projectId, ownerId, ownerDetails),
    updateJointTenantOwner: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) =>
        actions.owner.updateJointTenantOwner(clientNumber, projectId, ownerId, ownerDetails),
    // updateOwnerDetail: (clientNumber: number, projectId: number, ownerId: number, ownerDetails: IOwner) => actions.owner.updateOwnerDetail(clientNumber, projectId, ownerId, ownerDetails),
    getPhoneNumberTypes: () => actions.phoneNumberType.getPhoneNumberTypes(),
    resetBanner: () => actions.owner.resetBanner()
};

export default connect(mapStateToProps, mapDispatchToProps)(EditOwnerPage);



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/EditOwnerPage.tsx